import { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlocker } from 'react-router';
import { Dialog } from '@linktivity/link-ui';
import styles from './confimer.module.css';

const LeaveConfirmer = ({
  isBlocked,
  name,
  reset
}: {
  isBlocked: boolean;
  name: string;
  reset?: () => void;
}) => {
  const { t } = useTranslation();
  const [confirmLeave, setConfirmLeave] = useState(false);
  const blocker = useBlocker(isBlocked);
  const keepPage = useCallback(() => {
    blocker.reset?.();
    setConfirmLeave(false);
  }, [blocker]);
  const leavePage = useCallback(() => {
    blocker.proceed?.();
    reset?.();
    setConfirmLeave(false);
  }, [blocker, reset]);

  useEffect(() => {
    if (blocker.state === 'blocked') {
      setConfirmLeave(true);
    }
  }, [blocker]);
  return (
    <Dialog
      visible={confirmLeave}
      title={t('share.common.editConfirm')}
      onClose={keepPage}
      onOK={keepPage}
      onCancel={leavePage}
      okText={t('share.common.continueEditing')}
      cancelText={t('share.common.leaveCurrentPage')}
      className={styles.confirm}
    >
      <div className={styles.confirmBody}>
        <p className={styles.confirmContent}>
          {t('share.common.leaveCurrentPageConfirm', {
            name
          })}
        </p>
      </div>
    </Dialog>
  );
};

export default LeaveConfirmer;
